import React, { useMemo } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useChargingCardStatusLabelMap } from '../../charging-cards/hooks/use-charging-card-status-label-map'
import { Chip } from '@mui/material'
import { CardStatus } from '../../shared'

const useStyles = makeStyles()(theme => ({
  chip: {
    height: '26px',
  },
  active: {
    backgroundColor: theme.palette.chargingCard.status.active.background,
    color: theme.palette.chargingCard.status.active.text,
  },
  denied: {
    backgroundColor: theme.palette.chargingCard.status.rejected.background,
    color: theme.palette.chargingCard.status.rejected.text,
  },
  noAuth: {
    backgroundColor: theme.palette.chargingCard.status.inactive.background,
    color: theme.palette.chargingCard.status.inactive.text,
  },
}))

interface ChargingCardStatusChipProps {
  status: CardStatus
}

/** Component represent Charging Card status as chip */
export const ChargingCardStatusChip: React.FC<ChargingCardStatusChipProps> = ({ status }) => {
  const { classes, cx } = useStyles()
  const labelMap = useChargingCardStatusLabelMap()

  const statusMap: Record<CardStatus, string> = useMemo(
    () => ({
      ACTIVE: classes.active,
      REJECTED: classes.denied,
      INACTIVE: classes.noAuth,
      EXPIRED: classes.denied,
    }),
    [classes]
  )

  return <Chip label={labelMap[status]} className={cx(classes.chip, statusMap[status])} />
}
